import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  accountNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AccountParams = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Activity = {
  __typename?: 'Activity';
  defaultCategory?: Maybe<Category>;
  defaultCategoryId?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<ActivityGroup>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActivityGroup = {
  __typename?: 'ActivityGroup';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organizers?: Maybe<Array<Maybe<Person>>>;
};

export type ActivityGroupParams = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActivityParams = {
  defaultCategoryId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<ActivityGroupParams>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Article = {
  __typename?: 'Article';
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type ArticleParams = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type AuthenticateParameters = {
  email?: InputMaybe<Scalars['String']['input']>;
  google?: InputMaybe<GoogleAuth>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CategoryParams = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ContributionParams = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  migrationDocId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type Customer = {
  __typename?: 'Customer';
  contactChannel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  diffusion?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  howDiscovered?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageRights?: Maybe<Scalars['Boolean']['output']>;
  newsletter?: Maybe<Scalars['String']['output']>;
  signatureDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  wantReceiveInfo?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactChannel?: InputMaybe<Scalars['String']['input']>;
  diffusion?: InputMaybe<Scalars['String']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  howDiscovered?: InputMaybe<Scalars['String']['input']>;
  imageRights?: InputMaybe<Scalars['Boolean']['input']>;
  migrationId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  signatureDate?: InputMaybe<Scalars['Date']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  wantReceiveInfo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerResumeData = {
  __typename?: 'CustomerResumeData';
  sessions?: Maybe<Array<Maybe<Session>>>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
};

export type DateRange = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type GoogleAuth = {
  idToken?: InputMaybe<Scalars['String']['input']>;
};

export type IdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum Month {
  Apr = 'APR',
  Aug = 'AUG',
  Dec = 'DEC',
  Feb = 'FEB',
  Jan = 'JAN',
  Jul = 'JUL',
  Jun = 'JUN',
  Mar = 'MAR',
  May = 'MAY',
  Nov = 'NOV',
  Oct = 'OCT',
  Sep = 'SEP'
}

export type MonthlyIncomExpense = {
  __typename?: 'MonthlyIncomExpense';
  benefit?: Maybe<Scalars['Float']['output']>;
  expense?: Maybe<Scalars['Float']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type MonthlyLabeledValue = {
  __typename?: 'MonthlyLabeledValue';
  label?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type MonthlySessionValue = {
  __typename?: 'MonthlySessionValue';
  month?: Maybe<Scalars['String']['output']>;
  newPersons?: Maybe<Scalars['Int']['output']>;
  persons?: Maybe<Scalars['Int']['output']>;
  sessionPersons?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type MonthlyValue = {
  __typename?: 'MonthlyValue';
  month?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelSession?: Maybe<Session>;
  createAccount?: Maybe<Account>;
  createActivity?: Maybe<Activity>;
  createActivityGroup?: Maybe<ActivityGroup>;
  createArticle?: Maybe<Article>;
  createCategory?: Maybe<Category>;
  createCustomer?: Maybe<Person>;
  createOrder?: Maybe<Order>;
  createOrganizer?: Maybe<Person>;
  createPaymentMethod?: Maybe<PaymentMethod>;
  createPerson?: Maybe<Person>;
  createSession?: Maybe<Session>;
  createSubscription?: Maybe<Subscription>;
  createSubscriptionType?: Maybe<SubscriptionType>;
  createSupplier?: Maybe<Supplier>;
  createTherapist?: Maybe<Person>;
  createTransactionContribution?: Maybe<Transaction>;
  createTransactionOrder?: Maybe<Transaction>;
  createTransactionPayment?: Maybe<Transaction>;
  deleteAccount?: Maybe<Scalars['String']['output']>;
  deleteActivity?: Maybe<Scalars['String']['output']>;
  deleteActivityGroup?: Maybe<Scalars['String']['output']>;
  deleteArticle?: Maybe<Scalars['String']['output']>;
  deleteCategory?: Maybe<Scalars['String']['output']>;
  deleteCustomer?: Maybe<Scalars['String']['output']>;
  deleteOrder?: Maybe<Scalars['String']['output']>;
  deleteOrganizer?: Maybe<Scalars['String']['output']>;
  deletePaymentMethod?: Maybe<Scalars['String']['output']>;
  deletePerson?: Maybe<Scalars['String']['output']>;
  deleteSession?: Maybe<Scalars['String']['output']>;
  deleteSubscription?: Maybe<Scalars['String']['output']>;
  deleteSubscriptionType?: Maybe<Scalars['String']['output']>;
  deleteSupplier?: Maybe<Scalars['String']['output']>;
  deleteTherapist?: Maybe<Scalars['String']['output']>;
  deleteTransaction?: Maybe<Scalars['String']['output']>;
  enableSession?: Maybe<Session>;
  exchangeSession?: Maybe<Session>;
  root?: Maybe<Scalars['String']['output']>;
  updateAccount?: Maybe<Account>;
  updateActivity?: Maybe<Activity>;
  updateActivityGroup?: Maybe<ActivityGroup>;
  updateArticle?: Maybe<Article>;
  updateCategory?: Maybe<Category>;
  updateCustomer?: Maybe<Person>;
  updateOrder?: Maybe<Order>;
  updateOrganizer?: Maybe<Person>;
  updatePaymentMethod?: Maybe<PaymentMethod>;
  updatePerson?: Maybe<Person>;
  updateSubscription?: Maybe<Subscription>;
  updateSubscriptionType?: Maybe<SubscriptionType>;
  updateSupplier?: Maybe<Supplier>;
  updateTherapist?: Maybe<Person>;
  updateTransactionContribution?: Maybe<Transaction>;
  updateTransactionPayment?: Maybe<Transaction>;
};


export type MutationCancelSessionArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationCreateAccountArgs = {
  data?: InputMaybe<AccountParams>;
};


export type MutationCreateActivityArgs = {
  data?: InputMaybe<ActivityParams>;
};


export type MutationCreateActivityGroupArgs = {
  data?: InputMaybe<ActivityGroupParams>;
};


export type MutationCreateArticleArgs = {
  data?: InputMaybe<ArticleParams>;
};


export type MutationCreateCategoryArgs = {
  data?: InputMaybe<CategoryParams>;
};


export type MutationCreateCustomerArgs = {
  data?: InputMaybe<CustomerParams>;
};


export type MutationCreateOrderArgs = {
  data?: InputMaybe<OrderParams>;
};


export type MutationCreateOrganizerArgs = {
  data?: InputMaybe<OrganizerParams>;
};


export type MutationCreatePaymentMethodArgs = {
  data?: InputMaybe<PaymentMethodParams>;
};


export type MutationCreatePersonArgs = {
  data?: InputMaybe<PersonParams>;
};


export type MutationCreateSessionArgs = {
  data?: InputMaybe<SessionParams>;
};


export type MutationCreateSubscriptionArgs = {
  data?: InputMaybe<SubscriptionParams>;
};


export type MutationCreateSubscriptionTypeArgs = {
  data?: InputMaybe<SubscriptionTypeParams>;
};


export type MutationCreateSupplierArgs = {
  data?: InputMaybe<SupplierParams>;
};


export type MutationCreateTherapistArgs = {
  data?: InputMaybe<TherapistParams>;
};


export type MutationCreateTransactionContributionArgs = {
  data?: InputMaybe<ContributionParams>;
};


export type MutationCreateTransactionOrderArgs = {
  data?: InputMaybe<TransactionParams>;
};


export type MutationCreateTransactionPaymentArgs = {
  data?: InputMaybe<PaymentParams>;
};


export type MutationDeleteAccountArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteActivityArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteActivityGroupArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteArticleArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteCategoryArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteCustomerArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteOrderArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteOrganizerArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeletePaymentMethodArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeletePersonArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteSessionArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteSubscriptionArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteSubscriptionTypeArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteSupplierArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteTherapistArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationDeleteTransactionArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationEnableSessionArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationExchangeSessionArgs = {
  data?: InputMaybe<IdInput>;
};


export type MutationUpdateAccountArgs = {
  data?: InputMaybe<UpdateAccountParams>;
};


export type MutationUpdateActivityArgs = {
  data?: InputMaybe<UpdateActivityParams>;
};


export type MutationUpdateActivityGroupArgs = {
  data?: InputMaybe<UpdateActivityGroupParams>;
};


export type MutationUpdateArticleArgs = {
  data?: InputMaybe<UpdateArticleParams>;
};


export type MutationUpdateCategoryArgs = {
  data?: InputMaybe<UpdateCategoryParams>;
};


export type MutationUpdateCustomerArgs = {
  data?: InputMaybe<UpdateCustomerParams>;
};


export type MutationUpdateOrderArgs = {
  data?: InputMaybe<UpdateOrderParams>;
};


export type MutationUpdateOrganizerArgs = {
  data?: InputMaybe<UpdateOrganizerParams>;
};


export type MutationUpdatePaymentMethodArgs = {
  data?: InputMaybe<UpdatePaymentMethodParams>;
};


export type MutationUpdatePersonArgs = {
  data?: InputMaybe<UpdatePersonParams>;
};


export type MutationUpdateSubscriptionArgs = {
  data?: InputMaybe<UpdateSubscriptionParams>;
};


export type MutationUpdateSubscriptionTypeArgs = {
  data?: InputMaybe<UpdateSubscriptionTypeParams>;
};


export type MutationUpdateSupplierArgs = {
  data?: InputMaybe<UpdateSupplierParams>;
};


export type MutationUpdateTherapistArgs = {
  data?: InputMaybe<UpdateTherapistParams>;
};


export type MutationUpdateTransactionContributionArgs = {
  data?: InputMaybe<UpdateContributionParams>;
};


export type MutationUpdateTransactionPaymentArgs = {
  data?: InputMaybe<UpdatePaymentParams>;
};

export type NumberRange = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type Order = {
  __typename?: 'Order';
  customer?: Maybe<Person>;
  customerId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPayed?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<Maybe<OrderRow>>>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OrderParams = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  rows?: InputMaybe<Array<InputMaybe<OrderRowParams>>>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderRow = {
  __typename?: 'OrderRow';
  amount?: Maybe<Scalars['Float']['output']>;
  article?: Maybe<Article>;
  articleId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type OrderRowParams = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  articleId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSearch = {
  filters?: InputMaybe<OrderSearchFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderSearchFilters = {
  category?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  orderType?: InputMaybe<OrderType>;
  payed?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSessionIdInput = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderType {
  Article = 'ARTICLE',
  Session = 'SESSION'
}

export type OrdersSearchResult = {
  __typename?: 'OrdersSearchResult';
  orders?: Maybe<Array<Maybe<Order>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Organizer = {
  __typename?: 'Organizer';
  conditions?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OrganizerParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['Float']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PaymentMethodParams = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentParams = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  migrationDocId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type Person = {
  __typename?: 'Person';
  acceptedTerms?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  dni?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  migrationId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<Organizer>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  therapist?: Maybe<Therapist>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PersonParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  activities?: Maybe<Array<Maybe<Activity>>>;
  activity?: Maybe<Activity>;
  activityGroup?: Maybe<ActivityGroup>;
  activityGroups?: Maybe<Array<Maybe<ActivityGroup>>>;
  article?: Maybe<Article>;
  articles?: Maybe<Array<Maybe<Article>>>;
  authenticate?: Maybe<AuthenticatedUser>;
  authenticateGoogle?: Maybe<AuthenticatedUser>;
  authorized?: Maybe<User>;
  categories?: Maybe<Array<Maybe<Category>>>;
  category?: Maybe<Category>;
  customer?: Maybe<Person>;
  customerResume?: Maybe<CustomerResumeData>;
  customers?: Maybe<Array<Maybe<Person>>>;
  globalIncomesAndExpenses?: Maybe<Array<Maybe<MonthlyIncomExpense>>>;
  monthlyIncomesByTherapist?: Maybe<Array<Maybe<MonthlyLabeledValue>>>;
  order?: Maybe<Order>;
  orderBySessionId?: Maybe<Order>;
  orders?: Maybe<Array<Maybe<Order>>>;
  ordersSearch?: Maybe<OrdersSearchResult>;
  organizer?: Maybe<Person>;
  organizers?: Maybe<Array<Maybe<Person>>>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  people?: Maybe<Array<Maybe<Person>>>;
  person?: Maybe<Person>;
  root?: Maybe<Scalars['String']['output']>;
  searchSessions?: Maybe<SessionSearchResult>;
  session?: Maybe<Session>;
  sessionArticles?: Maybe<Array<Maybe<Article>>>;
  sessions?: Maybe<Array<Maybe<Session>>>;
  subscription?: Maybe<Subscription>;
  subscriptionType?: Maybe<SubscriptionType>;
  subscriptionTypes?: Maybe<Array<Maybe<SubscriptionType>>>;
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  supplier?: Maybe<Supplier>;
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  therapist?: Maybe<Person>;
  therapistPerformance?: Maybe<Array<Maybe<TherapistPerformance>>>;
  therapistResume?: Maybe<Array<Maybe<MonthlySessionValue>>>;
  therapists?: Maybe<Array<Maybe<Person>>>;
  transaction?: Maybe<Transaction>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  transactionsSearch?: Maybe<TransactionSearchResult>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryAccountArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryActivityArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryActivityGroupArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryArticleArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryAuthenticateArgs = {
  data?: InputMaybe<AuthenticateParameters>;
};


export type QueryAuthenticateGoogleArgs = {
  data?: InputMaybe<GoogleAuth>;
};


export type QueryCategoryArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryCustomerArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryCustomerResumeArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryOrderArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryOrderBySessionIdArgs = {
  data?: InputMaybe<OrderSessionIdInput>;
};


export type QueryOrdersSearchArgs = {
  data?: InputMaybe<OrderSearch>;
};


export type QueryOrganizerArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryPaymentMethodArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryPersonArgs = {
  data?: InputMaybe<IdInput>;
};


export type QuerySearchSessionsArgs = {
  data?: InputMaybe<SessionSearch>;
};


export type QuerySessionArgs = {
  data?: InputMaybe<IdInput>;
};


export type QuerySubscriptionArgs = {
  data?: InputMaybe<IdInput>;
};


export type QuerySubscriptionTypeArgs = {
  data?: InputMaybe<IdInput>;
};


export type QuerySupplierArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryTherapistArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryTherapistPerformanceArgs = {
  data: DateRange;
};


export type QueryTherapistResumeArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryTransactionArgs = {
  data?: InputMaybe<IdInput>;
};


export type QueryTransactionsSearchArgs = {
  data?: InputMaybe<TransactionSearch>;
};

export type Session = {
  __typename?: 'Session';
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Person>;
  customerId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  giftBox?: Maybe<Scalars['Boolean']['output']>;
  googleCalendarEventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  therapist?: Maybe<Person>;
  therapistId?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SessionParams = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  giftBox?: InputMaybe<Scalars['Boolean']['input']>;
  googleCalendarEventId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  therapistId?: InputMaybe<Scalars['String']['input']>;
};

export type SessionSearch = {
  filters?: InputMaybe<SessionSearchFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SessionSearchFilters = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  therapistId?: InputMaybe<Scalars['String']['input']>;
};

export type SessionSearchResult = {
  __typename?: 'SessionSearchResult';
  sessions?: Maybe<Array<Maybe<Session>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  activityGroup?: Maybe<ActivityGroup>;
  activityGroupId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Month>;
  subscriptionType?: Maybe<SubscriptionType>;
  subscriptionTypeId?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionParams = {
  activityGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['Date']['input']>;
  month?: InputMaybe<Month>;
  subscriptionTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type SubscriptionTypeParams = {
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nif?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SupplierParams = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nif?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type Therapist = {
  __typename?: 'Therapist';
  calendarChannelId?: Maybe<Scalars['String']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  calendarResourceId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultPrice?: Maybe<Scalars['Float']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  irpf?: Maybe<Scalars['Float']['output']>;
  licenseCode?: Maybe<Scalars['String']['output']>;
  nextCalendarTokenSync?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TherapistParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  calendarChannelId?: InputMaybe<Scalars['String']['input']>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  calendarResourceId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['Int']['input']>;
  defaultPrice?: InputMaybe<Scalars['Float']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  irpf?: InputMaybe<Scalars['Float']['input']>;
  licenseCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextCalendarTokenSync?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type TherapistPerformance = {
  __typename?: 'TherapistPerformance';
  newSessions?: Maybe<Scalars['Int']['output']>;
  sessions?: Maybe<Scalars['Int']['output']>;
  therapistIrpf?: Maybe<Scalars['Float']['output']>;
  therapistName?: Maybe<Scalars['String']['output']>;
  totalInvoiced?: Maybe<Scalars['Float']['output']>;
  totalIrpf?: Maybe<Scalars['Float']['output']>;
  totalOhana?: Maybe<Scalars['Float']['output']>;
  totalTherapist?: Maybe<Scalars['Float']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  account?: Maybe<Account>;
  amount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<TransactionContribution>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  migratioDocId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<TransactionOrder>;
  payment?: Maybe<TransactionPayment>;
  paymentMethod?: Maybe<PaymentMethod>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TransactionContribution = {
  __typename?: 'TransactionContribution';
  category?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<TransactionPerson>;
  id?: Maybe<Scalars['String']['output']>;
};

export type TransactionFacets = {
  __typename?: 'TransactionFacets';
  accounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  transactionTypes?: Maybe<Array<Maybe<TransactionType>>>;
};

export type TransactionOrder = {
  __typename?: 'TransactionOrder';
  customer?: Maybe<TransactionPerson>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Maybe<TransactionOrderRow>>>;
};

export type TransactionOrderRow = {
  __typename?: 'TransactionOrderRow';
  amount?: Maybe<Scalars['Float']['output']>;
  article?: Maybe<TransactionOrderRowArticle>;
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  payedPrice?: Maybe<Scalars['Float']['output']>;
  session?: Maybe<TransactionOrderRowSession>;
};

export type TransactionOrderRowArticle = {
  __typename?: 'TransactionOrderRowArticle';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type TransactionOrderRowSession = {
  __typename?: 'TransactionOrderRowSession';
  date?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  therapist?: Maybe<TransactionPerson>;
};

export type TransactionParams = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  migratioDocId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type TransactionPayment = {
  __typename?: 'TransactionPayment';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<TransactionSupplier>;
};

export type TransactionPerson = {
  __typename?: 'TransactionPerson';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['Float']['output']>;
  dni?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  irpf?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type TransactionSearch = {
  filters?: InputMaybe<TransactionSearchFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TransactionSortParams>;
};

export type TransactionSearchFilters = {
  account?: InputMaybe<Scalars['String']['input']>;
  amountRange?: InputMaybe<NumberRange>;
  category?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerSurname?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  therapistName?: InputMaybe<Scalars['String']['input']>;
  therapistSurname?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionSearchResult = {
  __typename?: 'TransactionSearchResult';
  facets?: Maybe<TransactionFacets>;
  total?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
};

export type TransactionSortParams = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionSupplier = {
  __typename?: 'TransactionSupplier';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nif?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum TransactionType {
  Expense = 'EXPENSE',
  Income = 'INCOME'
}

export type UpdateAccountParams = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActivityGroupParams = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateActivityParams = {
  defaultCategoryId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<UpdateActivityGroupParams>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArticleParams = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCategoryParams = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContributionParams = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  migrationDocId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type UpdateCustomerParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactChannel?: InputMaybe<Scalars['String']['input']>;
  diffusion?: InputMaybe<Scalars['String']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  howDiscovered?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageRights?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  signatureDate?: InputMaybe<Scalars['Date']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  wantReceiveInfo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderParams = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<InputMaybe<UpdateOrderRowParams>>>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderRowParams = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  articleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizerParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['Float']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentMethodParams = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentParams = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  migrationDocId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type UpdatePersonParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionParams = {
  activityGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Month>;
  subscriptionTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionTypeParams = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSupplierParams = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nif?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTherapistParams = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  calendarChannelId?: InputMaybe<Scalars['String']['input']>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  calendarResourceId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['Int']['input']>;
  defaultPrice?: InputMaybe<Scalars['Float']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  irpf?: InputMaybe<Scalars['Float']['input']>;
  licenseCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextCalendarTokenSync?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTransactionParams = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  migratioDocId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AccountFragmentFragment = { __typename?: 'Account', id?: string, name?: string, accountNumber?: string };

export type GetAccountQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } };

export type GetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountsQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', id?: string, name?: string, accountNumber?: string }> };

export type CreateAccountMutationVariables = Exact<{
  data?: InputMaybe<AccountParams>;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } };

export type UpdateAccountMutationVariables = Exact<{
  data?: InputMaybe<UpdateAccountParams>;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } };

export type DeleteAccountMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: string };

export type ActivityFragmentFragment = { __typename?: 'Activity', id?: string, name?: string, defaultCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any }, groups?: Array<{ __typename?: 'ActivityGroup', id?: string, name?: string, organizers?: Array<{ __typename?: 'Person', id?: string, name?: string }> }> };

export type GetActivityQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', id?: string, name?: string, defaultCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any }, groups?: Array<{ __typename?: 'ActivityGroup', id?: string, name?: string, organizers?: Array<{ __typename?: 'Person', id?: string, name?: string }> }> } };

export type GetActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivitiesQuery = { __typename?: 'Query', activities?: Array<{ __typename?: 'Activity', id?: string, name?: string, defaultCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any }, groups?: Array<{ __typename?: 'ActivityGroup', id?: string, name?: string, organizers?: Array<{ __typename?: 'Person', id?: string, name?: string }> }> }> };

export type CreateActivityMutationVariables = Exact<{
  data?: InputMaybe<ActivityParams>;
}>;


export type CreateActivityMutation = { __typename?: 'Mutation', createActivity?: { __typename?: 'Activity', id?: string, name?: string, defaultCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any }, groups?: Array<{ __typename?: 'ActivityGroup', id?: string, name?: string, organizers?: Array<{ __typename?: 'Person', id?: string, name?: string }> }> } };

export type UpdateActivityMutationVariables = Exact<{
  data?: InputMaybe<UpdateActivityParams>;
}>;


export type UpdateActivityMutation = { __typename?: 'Mutation', updateActivity?: { __typename?: 'Activity', id?: string, name?: string, defaultCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any }, groups?: Array<{ __typename?: 'ActivityGroup', id?: string, name?: string, organizers?: Array<{ __typename?: 'Person', id?: string, name?: string }> }> } };

export type DeleteActivityMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteActivityMutation = { __typename?: 'Mutation', deleteActivity?: string };

export type ArticleFragmentFragment = { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } };

export type GetArticleQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } } };

export type GetArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArticlesQuery = { __typename?: 'Query', articles?: Array<{ __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }> };

export type GetSessionArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionArticlesQuery = { __typename?: 'Query', sessionArticles?: Array<{ __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }> };

export type CreateArticleMutationVariables = Exact<{
  data?: InputMaybe<ArticleParams>;
}>;


export type CreateArticleMutation = { __typename?: 'Mutation', createArticle?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } } };

export type UpdateArticleMutationVariables = Exact<{
  data?: InputMaybe<UpdateArticleParams>;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', updateArticle?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } } };

export type DeleteArticleMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteArticleMutation = { __typename?: 'Mutation', deleteArticle?: string };

export type AuthenticateQueryVariables = Exact<{
  data?: InputMaybe<AuthenticateParameters>;
}>;


export type AuthenticateQuery = { __typename?: 'Query', authenticate?: { __typename?: 'AuthenticatedUser', email?: string, name?: string, id?: string, token?: string } };

export type AuthenticateGoogleQueryVariables = Exact<{
  data?: InputMaybe<GoogleAuth>;
}>;


export type AuthenticateGoogleQuery = { __typename?: 'Query', authenticateGoogle?: { __typename?: 'AuthenticatedUser', email?: string, name?: string, id?: string, token?: string } };

export type AuthorizedQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorizedQuery = { __typename?: 'Query', authorized?: { __typename?: 'User', email?: string, name?: string, id?: string } };

export type CategoryFragmentFragment = { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any };

export type GetCategoryQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetCategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any }> };

export type CreateCategoryMutationVariables = Exact<{
  data?: InputMaybe<CategoryParams>;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } };

export type UpdateCategoryMutationVariables = Exact<{
  data?: InputMaybe<UpdateCategoryParams>;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } };

export type DeleteCategoryMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory?: string };

export type GetCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomersQuery = { __typename?: 'Query', customers?: Array<{ __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }> };

export type GetCustomerQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type CreateCustomerMutationVariables = Exact<{
  data?: InputMaybe<CustomerParams>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type UpdateCustomerMutationVariables = Exact<{
  data?: InputMaybe<UpdateCustomerParams>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type DeleteCustomerMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer?: string };

export type GetCustomerResumeQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetCustomerResumeQuery = { __typename?: 'Query', customerResume?: { __typename?: 'CustomerResumeData', transactions?: Array<{ __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } }>, sessions?: Array<{ __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } }> } };

export type GetGlobalIncomeExpenseQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalIncomeExpenseQuery = { __typename?: 'Query', globalIncomesAndExpenses?: Array<{ __typename?: 'MonthlyIncomExpense', benefit?: number, income?: number, expense?: number, year?: string, month?: string }> };

export type GetTherapistPerformanceQueryVariables = Exact<{
  data: DateRange;
}>;


export type GetTherapistPerformanceQuery = { __typename?: 'Query', therapistPerformance?: Array<{ __typename?: 'TherapistPerformance', therapistName?: string, sessions?: number, totalInvoiced?: number, totalOhana?: number, totalTherapist?: number, therapistIrpf?: number, totalIrpf?: number, newSessions?: number }> };

export type OrderFragmentFragment = { __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> };

export type GetOrderQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> } };

export type GetOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersQuery = { __typename?: 'Query', orders?: Array<{ __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> }> };

export type CreateOrderMutationVariables = Exact<{
  data?: InputMaybe<OrderParams>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> } };

export type UpdateOrderMutationVariables = Exact<{
  data?: InputMaybe<UpdateOrderParams>;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> } };

export type DeleteOrderMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: string };

export type SearchOrdersQueryVariables = Exact<{
  data?: InputMaybe<OrderSearch>;
}>;


export type SearchOrdersQuery = { __typename?: 'Query', ordersSearch?: { __typename?: 'OrdersSearchResult', total?: number, orders?: Array<{ __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> }> } };

export type GetOrderBySessionIdQueryVariables = Exact<{
  data?: InputMaybe<OrderSessionIdInput>;
}>;


export type GetOrderBySessionIdQuery = { __typename?: 'Query', orderBySessionId?: { __typename?: 'Order', id?: string, date?: any, isPayed?: boolean, transactionId?: string, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string }, rows?: Array<{ __typename?: 'OrderRow', id?: string, amount?: number, price?: number, article?: { __typename?: 'Article', id?: string, name?: string, price?: number, category?: { __typename?: 'Category', id?: string, name?: string } }, session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, category?: { __typename?: 'Category', id?: string, name?: string }, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } }> } };

export type GetOrganizersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizersQuery = { __typename?: 'Query', organizers?: Array<{ __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }> };

export type GetOrganizerQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetOrganizerQuery = { __typename?: 'Query', organizer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type CreateOrganizerMutationVariables = Exact<{
  data?: InputMaybe<OrganizerParams>;
}>;


export type CreateOrganizerMutation = { __typename?: 'Mutation', createOrganizer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type UpdateOrganizerMutationVariables = Exact<{
  data?: InputMaybe<UpdateOrganizerParams>;
}>;


export type UpdateOrganizerMutation = { __typename?: 'Mutation', updateOrganizer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type DeleteOrganizerMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteOrganizerMutation = { __typename?: 'Mutation', deleteOrganizer?: string };

export type PaymentMethodFragmentFragment = { __typename?: 'PaymentMethod', id?: string, name?: string };

export type GetPaymentMethodQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetPaymentMethodQuery = { __typename?: 'Query', paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string } };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string, name?: string }> };

export type CreatePaymentMethodMutationVariables = Exact<{
  data?: InputMaybe<PaymentMethodParams>;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string } };

export type UpdatePaymentMethodMutationVariables = Exact<{
  data?: InputMaybe<UpdatePaymentMethodParams>;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string } };

export type DeletePaymentMethodMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: string };

export type PersonFragmentFragment = { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } };

export type GetPeopleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeopleQuery = { __typename?: 'Query', people?: Array<{ __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }> };

export type GetPersonQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetPersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type CreatePersonMutationVariables = Exact<{
  data?: InputMaybe<PersonParams>;
}>;


export type CreatePersonMutation = { __typename?: 'Mutation', createPerson?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type UpdatePersonMutationVariables = Exact<{
  data?: InputMaybe<UpdatePersonParams>;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type DeletePersonMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', deletePerson?: string };

export type SessionFragmentFragment = { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } };

export type GetSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionsQuery = { __typename?: 'Query', sessions?: Array<{ __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } }> };

export type GetSessionQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetSessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } };

export type CreateSessionMutationVariables = Exact<{
  data?: InputMaybe<SessionParams>;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } };

export type SearchSessionsQueryVariables = Exact<{
  data?: InputMaybe<SessionSearch>;
}>;


export type SearchSessionsQuery = { __typename?: 'Query', searchSessions?: { __typename?: 'SessionSearchResult', total?: number, sessions?: Array<{ __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } }> } };

export type DeleteSessionMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteSessionMutation = { __typename?: 'Mutation', deleteSession?: string };

export type CancelSessionMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type CancelSessionMutation = { __typename?: 'Mutation', cancelSession?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } };

export type EnableSessionMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type EnableSessionMutation = { __typename?: 'Mutation', enableSession?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } };

export type ExchangeSessionMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type ExchangeSessionMutation = { __typename?: 'Mutation', exchangeSession?: { __typename?: 'Session', id?: string, date?: any, duration?: number, notes?: string, cancelledAt?: any, giftBox?: boolean, therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, customer?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }, transaction?: { __typename?: 'Transaction', id?: string } } };

export type SupplierFragmentFragment = { __typename?: 'Supplier', id?: string, name?: string, email?: string, phone?: string, nif?: string, website?: string, category?: { __typename?: 'Category', id?: string, name?: string } };

export type GetSupplierQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetSupplierQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id?: string, name?: string, email?: string, phone?: string, nif?: string, website?: string, category?: { __typename?: 'Category', id?: string, name?: string } } };

export type GetSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersQuery = { __typename?: 'Query', suppliers?: Array<{ __typename?: 'Supplier', id?: string, name?: string, email?: string, phone?: string, nif?: string, website?: string, category?: { __typename?: 'Category', id?: string, name?: string } }> };

export type CreateSupplierMutationVariables = Exact<{
  data?: InputMaybe<SupplierParams>;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier?: { __typename?: 'Supplier', id?: string, name?: string, email?: string, phone?: string, nif?: string, website?: string, category?: { __typename?: 'Category', id?: string, name?: string } } };

export type UpdateSupplierMutationVariables = Exact<{
  data?: InputMaybe<UpdateSupplierParams>;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier?: { __typename?: 'Supplier', id?: string, name?: string, email?: string, phone?: string, nif?: string, website?: string, category?: { __typename?: 'Category', id?: string, name?: string } } };

export type DeleteSupplierMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteSupplierMutation = { __typename?: 'Mutation', deleteSupplier?: string };

export type GetTherapistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistsQuery = { __typename?: 'Query', therapists?: Array<{ __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } }> };

export type GetTherapistQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetTherapistQuery = { __typename?: 'Query', therapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type CreateTherapistMutationVariables = Exact<{
  data?: InputMaybe<TherapistParams>;
}>;


export type CreateTherapistMutation = { __typename?: 'Mutation', createTherapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type UpdateTherapistMutationVariables = Exact<{
  data?: InputMaybe<UpdateTherapistParams>;
}>;


export type UpdateTherapistMutation = { __typename?: 'Mutation', updateTherapist?: { __typename?: 'Person', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, therapist?: { __typename?: 'Therapist', id?: string, conditions?: number, licenseCode?: string, irpf?: number, defaultPrice?: number, calendarId?: string, nextCalendarTokenSync?: string, disabled?: boolean, category?: { __typename?: 'Category', id?: string, name?: string, createdAt?: any, updatedAt?: any } }, customer?: { __typename?: 'Customer', id?: string, diffusion?: string, wantReceiveInfo?: boolean, imageRights?: boolean, contactChannel?: string, howDiscovered?: string, documentType?: string, signatureDate?: any }, organizer?: { __typename?: 'Organizer', id?: string, conditions?: number } } };

export type DeleteTherapistMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteTherapistMutation = { __typename?: 'Mutation', deleteTherapist?: string };

export type GetTherapistResumeQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetTherapistResumeQuery = { __typename?: 'Query', therapistResume?: Array<{ __typename?: 'MonthlySessionValue', year?: string, month?: string, value?: string, sessionPersons?: number, persons?: number, newPersons?: number }> };

export type TransactionPersonFragmentFragment = { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number };

export type TransactionFacetsFragmentFragment = { __typename?: 'TransactionFacets', categories?: Array<string>, accounts?: Array<string>, transactionTypes?: Array<TransactionType> };

export type TransactionFragmentFragment = { __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } };

export type GetTransactionQueryVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type GetTransactionQuery = { __typename?: 'Query', transaction?: { __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } } };

export type GetTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionsQuery = { __typename?: 'Query', transactions?: Array<{ __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } }> };

export type SearchTransactionsQueryVariables = Exact<{
  data?: InputMaybe<TransactionSearch>;
}>;


export type SearchTransactionsQuery = { __typename?: 'Query', transactionsSearch?: { __typename?: 'TransactionSearchResult', total?: number, transactions?: Array<{ __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } }>, facets?: { __typename?: 'TransactionFacets', categories?: Array<string>, accounts?: Array<string>, transactionTypes?: Array<TransactionType> } } };

export type CreateTransactionOrderMutationVariables = Exact<{
  data?: InputMaybe<TransactionParams>;
}>;


export type CreateTransactionOrderMutation = { __typename?: 'Mutation', createTransactionOrder?: { __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } } };

export type CreateTransactionContributionMutationVariables = Exact<{
  data?: InputMaybe<ContributionParams>;
}>;


export type CreateTransactionContributionMutation = { __typename?: 'Mutation', createTransactionContribution?: { __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } } };

export type CreateTransactionPaymentMutationVariables = Exact<{
  data?: InputMaybe<PaymentParams>;
}>;


export type CreateTransactionPaymentMutation = { __typename?: 'Mutation', createTransactionPayment?: { __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } } };

export type UpdateTransactionPaymentMutationVariables = Exact<{
  data?: InputMaybe<UpdatePaymentParams>;
}>;


export type UpdateTransactionPaymentMutation = { __typename?: 'Mutation', updateTransactionPayment?: { __typename?: 'Transaction', id?: string, date?: any, type?: TransactionType, amount?: number, notes?: string, createdAt?: any, updatedAt?: any, payment?: { __typename?: 'TransactionPayment', id?: string, category?: string, supplier?: { __typename?: 'TransactionSupplier', id?: string, name?: string, email?: string, phone?: string, website?: string, nif?: string } }, contribution?: { __typename?: 'TransactionContribution', id?: string, category?: string, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } }, order?: { __typename?: 'TransactionOrder', id?: string, date?: any, customer?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number }, rows?: Array<{ __typename?: 'TransactionOrderRow', id?: string, amount?: number, payedPrice?: number, category?: string, article?: { __typename?: 'TransactionOrderRowArticle', id?: string, name?: string, price?: number }, session?: { __typename?: 'TransactionOrderRowSession', id?: string, date?: any, duration?: number, notes?: string, price?: number, therapist?: { __typename?: 'TransactionPerson', id?: string, name?: string, surname?: string, fullName?: string, email?: string, phone?: string, dni?: string, address?: string, city?: string, conditions?: number, irpf?: number } } }> }, paymentMethod?: { __typename?: 'PaymentMethod', id?: string, name?: string }, account?: { __typename?: 'Account', id?: string, name?: string, accountNumber?: string } } };

export type DeleteTransactionMutationVariables = Exact<{
  data?: InputMaybe<IdInput>;
}>;


export type DeleteTransactionMutation = { __typename?: 'Mutation', deleteTransaction?: string };

export const CategoryFragmentFragmentDoc = gql`
    fragment CategoryFragment on Category {
  id
  name
  createdAt
  updatedAt
}
    `;
export const ActivityFragmentFragmentDoc = gql`
    fragment ActivityFragment on Activity {
  id
  name
  defaultCategory {
    ...CategoryFragment
  }
  groups {
    id
    name
    organizers {
      id
      name
    }
  }
}
    ${CategoryFragmentFragmentDoc}`;
export const ArticleFragmentFragmentDoc = gql`
    fragment ArticleFragment on Article {
  id
  name
  price
  category {
    id
    name
  }
}
    `;
export const PersonFragmentFragmentDoc = gql`
    fragment PersonFragment on Person {
  id
  name
  surname
  fullName @client
  email
  phone
  dni
  address
  city
  therapist {
    id
    conditions
    licenseCode
    irpf
    category {
      ...CategoryFragment
    }
    defaultPrice
    calendarId
    nextCalendarTokenSync
    disabled
  }
  customer {
    id
    diffusion
    wantReceiveInfo
    imageRights
    contactChannel
    howDiscovered
    documentType
    signatureDate
  }
  organizer {
    id
    conditions
  }
}
    ${CategoryFragmentFragmentDoc}`;
export const SessionFragmentFragmentDoc = gql`
    fragment SessionFragment on Session {
  id
  date
  duration
  notes
  therapist {
    ...PersonFragment
  }
  customer {
    ...PersonFragment
  }
  transaction {
    id
  }
  cancelledAt
  giftBox
}
    ${PersonFragmentFragmentDoc}`;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  id
  date
  isPayed
  customer {
    id
    name
    surname
  }
  rows {
    id
    article {
      ...ArticleFragment
      category {
        id
        name
      }
    }
    session {
      ...SessionFragment
      category {
        id
        name
      }
    }
    amount
    price
  }
  transactionId
}
    ${ArticleFragmentFragmentDoc}
${SessionFragmentFragmentDoc}`;
export const SupplierFragmentFragmentDoc = gql`
    fragment SupplierFragment on Supplier {
  id
  name
  email
  phone
  nif
  website
  category {
    id
    name
  }
}
    `;
export const TransactionFacetsFragmentFragmentDoc = gql`
    fragment TransactionFacetsFragment on TransactionFacets {
  categories
  accounts
  transactionTypes
}
    `;
export const TransactionPersonFragmentFragmentDoc = gql`
    fragment TransactionPersonFragment on TransactionPerson {
  id
  name
  surname
  fullName @client
  email
  phone
  dni
  address
  city
  conditions
  irpf
}
    `;
export const PaymentMethodFragmentFragmentDoc = gql`
    fragment PaymentMethodFragment on PaymentMethod {
  id
  name
}
    `;
export const AccountFragmentFragmentDoc = gql`
    fragment AccountFragment on Account {
  id
  name
  accountNumber
}
    `;
export const TransactionFragmentFragmentDoc = gql`
    fragment TransactionFragment on Transaction {
  id
  date
  type
  amount
  notes
  payment {
    id
    supplier {
      id
      name
      email
      phone
      website
      nif
    }
    category
  }
  contribution {
    id
    customer {
      ...TransactionPersonFragment
    }
    category
  }
  order {
    id
    date
    customer {
      ...TransactionPersonFragment
    }
    rows {
      id
      amount
      payedPrice
      article {
        id
        name
        price
      }
      session {
        id
        date
        duration
        notes
        price
        therapist {
          ...TransactionPersonFragment
        }
      }
      category
    }
  }
  paymentMethod {
    ...PaymentMethodFragment
  }
  account {
    ...AccountFragment
  }
  createdAt
  updatedAt
}
    ${TransactionPersonFragmentFragmentDoc}
${PaymentMethodFragmentFragmentDoc}
${AccountFragmentFragmentDoc}`;
export const GetAccountDocument = gql`
    query getAccount($data: IdInput) {
  account(data: $data) {
    ...AccountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountsDocument = gql`
    query getAccounts {
  accounts {
    ...AccountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($data: AccountParams) {
  createAccount(data: $data) {
    ...AccountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($data: UpdateAccountParams) {
  updateAccount(data: $data) {
    ...AccountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($data: IdInput) {
  deleteAccount(data: $data)
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const GetActivityDocument = gql`
    query getActivity($data: IdInput) {
  activity(data: $data) {
    ...ActivityFragment
  }
}
    ${ActivityFragmentFragmentDoc}`;

/**
 * __useGetActivityQuery__
 *
 * To run a query within a React component, call `useGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
      }
export function useGetActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
        }
export function useGetActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
        }
export type GetActivityQueryHookResult = ReturnType<typeof useGetActivityQuery>;
export type GetActivityLazyQueryHookResult = ReturnType<typeof useGetActivityLazyQuery>;
export type GetActivitySuspenseQueryHookResult = ReturnType<typeof useGetActivitySuspenseQuery>;
export type GetActivityQueryResult = Apollo.QueryResult<GetActivityQuery, GetActivityQueryVariables>;
export const GetActivitiesDocument = gql`
    query getActivities {
  activities {
    ...ActivityFragment
  }
}
    ${ActivityFragmentFragmentDoc}`;

/**
 * __useGetActivitiesQuery__
 *
 * To run a query within a React component, call `useGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
      }
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export function useGetActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export type GetActivitiesQueryHookResult = ReturnType<typeof useGetActivitiesQuery>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetActivitiesSuspenseQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const CreateActivityDocument = gql`
    mutation createActivity($data: ActivityParams) {
  createActivity(data: $data) {
    ...ActivityFragment
  }
}
    ${ActivityFragmentFragmentDoc}`;
export type CreateActivityMutationFn = Apollo.MutationFunction<CreateActivityMutation, CreateActivityMutationVariables>;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutation, { data, loading, error }] = useCreateActivityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateActivityMutation, CreateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActivityMutation, CreateActivityMutationVariables>(CreateActivityDocument, options);
      }
export type CreateActivityMutationHookResult = ReturnType<typeof useCreateActivityMutation>;
export type CreateActivityMutationResult = Apollo.MutationResult<CreateActivityMutation>;
export type CreateActivityMutationOptions = Apollo.BaseMutationOptions<CreateActivityMutation, CreateActivityMutationVariables>;
export const UpdateActivityDocument = gql`
    mutation updateActivity($data: UpdateActivityParams) {
  updateActivity(data: $data) {
    ...ActivityFragment
  }
}
    ${ActivityFragmentFragmentDoc}`;
export type UpdateActivityMutationFn = Apollo.MutationFunction<UpdateActivityMutation, UpdateActivityMutationVariables>;

/**
 * __useUpdateActivityMutation__
 *
 * To run a mutation, you first call `useUpdateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityMutation, { data, loading, error }] = useUpdateActivityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityMutation, UpdateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, options);
      }
export type UpdateActivityMutationHookResult = ReturnType<typeof useUpdateActivityMutation>;
export type UpdateActivityMutationResult = Apollo.MutationResult<UpdateActivityMutation>;
export type UpdateActivityMutationOptions = Apollo.BaseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const DeleteActivityDocument = gql`
    mutation deleteActivity($data: IdInput) {
  deleteActivity(data: $data)
}
    `;
export type DeleteActivityMutationFn = Apollo.MutationFunction<DeleteActivityMutation, DeleteActivityMutationVariables>;

/**
 * __useDeleteActivityMutation__
 *
 * To run a mutation, you first call `useDeleteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityMutation, { data, loading, error }] = useDeleteActivityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteActivityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActivityMutation, DeleteActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActivityMutation, DeleteActivityMutationVariables>(DeleteActivityDocument, options);
      }
export type DeleteActivityMutationHookResult = ReturnType<typeof useDeleteActivityMutation>;
export type DeleteActivityMutationResult = Apollo.MutationResult<DeleteActivityMutation>;
export type DeleteActivityMutationOptions = Apollo.BaseMutationOptions<DeleteActivityMutation, DeleteActivityMutationVariables>;
export const GetArticleDocument = gql`
    query getArticle($data: IdInput) {
  article(data: $data) {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a React component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetArticleQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
      }
export function useGetArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
export function useGetArticleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
export type GetArticleQueryHookResult = ReturnType<typeof useGetArticleQuery>;
export type GetArticleLazyQueryHookResult = ReturnType<typeof useGetArticleLazyQuery>;
export type GetArticleSuspenseQueryHookResult = ReturnType<typeof useGetArticleSuspenseQuery>;
export type GetArticleQueryResult = Apollo.QueryResult<GetArticleQuery, GetArticleQueryVariables>;
export const GetArticlesDocument = gql`
    query getArticles {
  articles {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
      }
export function useGetArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesSuspenseQueryHookResult = ReturnType<typeof useGetArticlesSuspenseQuery>;
export type GetArticlesQueryResult = Apollo.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export const GetSessionArticlesDocument = gql`
    query getSessionArticles {
  sessionArticles {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;

/**
 * __useGetSessionArticlesQuery__
 *
 * To run a query within a React component, call `useGetSessionArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>(GetSessionArticlesDocument, options);
      }
export function useGetSessionArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>(GetSessionArticlesDocument, options);
        }
export function useGetSessionArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>(GetSessionArticlesDocument, options);
        }
export type GetSessionArticlesQueryHookResult = ReturnType<typeof useGetSessionArticlesQuery>;
export type GetSessionArticlesLazyQueryHookResult = ReturnType<typeof useGetSessionArticlesLazyQuery>;
export type GetSessionArticlesSuspenseQueryHookResult = ReturnType<typeof useGetSessionArticlesSuspenseQuery>;
export type GetSessionArticlesQueryResult = Apollo.QueryResult<GetSessionArticlesQuery, GetSessionArticlesQueryVariables>;
export const CreateArticleDocument = gql`
    mutation createArticle($data: ArticleParams) {
  createArticle(data: $data) {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type CreateArticleMutationFn = Apollo.MutationFunction<CreateArticleMutation, CreateArticleMutationVariables>;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateArticleMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticleMutation, CreateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(CreateArticleDocument, options);
      }
export type CreateArticleMutationHookResult = ReturnType<typeof useCreateArticleMutation>;
export type CreateArticleMutationResult = Apollo.MutationResult<CreateArticleMutation>;
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation updateArticle($data: UpdateArticleParams) {
  updateArticle(data: $data) {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const DeleteArticleDocument = gql`
    mutation deleteArticle($data: IdInput) {
  deleteArticle(data: $data)
}
    `;
export type DeleteArticleMutationFn = Apollo.MutationFunction<DeleteArticleMutation, DeleteArticleMutationVariables>;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteArticleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticleMutation, DeleteArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(DeleteArticleDocument, options);
      }
export type DeleteArticleMutationHookResult = ReturnType<typeof useDeleteArticleMutation>;
export type DeleteArticleMutationResult = Apollo.MutationResult<DeleteArticleMutation>;
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables>;
export const AuthenticateDocument = gql`
    query authenticate($data: AuthenticateParameters) {
  authenticate(data: $data) {
    email
    name
    id
    token
  }
}
    `;

/**
 * __useAuthenticateQuery__
 *
 * To run a query within a React component, call `useAuthenticateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAuthenticateQuery(baseOptions?: Apollo.QueryHookOptions<AuthenticateQuery, AuthenticateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticateQuery, AuthenticateQueryVariables>(AuthenticateDocument, options);
      }
export function useAuthenticateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticateQuery, AuthenticateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticateQuery, AuthenticateQueryVariables>(AuthenticateDocument, options);
        }
export function useAuthenticateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthenticateQuery, AuthenticateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthenticateQuery, AuthenticateQueryVariables>(AuthenticateDocument, options);
        }
export type AuthenticateQueryHookResult = ReturnType<typeof useAuthenticateQuery>;
export type AuthenticateLazyQueryHookResult = ReturnType<typeof useAuthenticateLazyQuery>;
export type AuthenticateSuspenseQueryHookResult = ReturnType<typeof useAuthenticateSuspenseQuery>;
export type AuthenticateQueryResult = Apollo.QueryResult<AuthenticateQuery, AuthenticateQueryVariables>;
export const AuthenticateGoogleDocument = gql`
    query authenticateGoogle($data: GoogleAuth) {
  authenticateGoogle(data: $data) {
    email
    name
    id
    token
  }
}
    `;

/**
 * __useAuthenticateGoogleQuery__
 *
 * To run a query within a React component, call `useAuthenticateGoogleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateGoogleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateGoogleQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAuthenticateGoogleQuery(baseOptions?: Apollo.QueryHookOptions<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>(AuthenticateGoogleDocument, options);
      }
export function useAuthenticateGoogleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>(AuthenticateGoogleDocument, options);
        }
export function useAuthenticateGoogleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>(AuthenticateGoogleDocument, options);
        }
export type AuthenticateGoogleQueryHookResult = ReturnType<typeof useAuthenticateGoogleQuery>;
export type AuthenticateGoogleLazyQueryHookResult = ReturnType<typeof useAuthenticateGoogleLazyQuery>;
export type AuthenticateGoogleSuspenseQueryHookResult = ReturnType<typeof useAuthenticateGoogleSuspenseQuery>;
export type AuthenticateGoogleQueryResult = Apollo.QueryResult<AuthenticateGoogleQuery, AuthenticateGoogleQueryVariables>;
export const AuthorizedDocument = gql`
    query authorized {
  authorized {
    email
    name
    id
  }
}
    `;

/**
 * __useAuthorizedQuery__
 *
 * To run a query within a React component, call `useAuthorizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorizedQuery(baseOptions?: Apollo.QueryHookOptions<AuthorizedQuery, AuthorizedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorizedQuery, AuthorizedQueryVariables>(AuthorizedDocument, options);
      }
export function useAuthorizedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorizedQuery, AuthorizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorizedQuery, AuthorizedQueryVariables>(AuthorizedDocument, options);
        }
export function useAuthorizedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorizedQuery, AuthorizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorizedQuery, AuthorizedQueryVariables>(AuthorizedDocument, options);
        }
export type AuthorizedQueryHookResult = ReturnType<typeof useAuthorizedQuery>;
export type AuthorizedLazyQueryHookResult = ReturnType<typeof useAuthorizedLazyQuery>;
export type AuthorizedSuspenseQueryHookResult = ReturnType<typeof useAuthorizedSuspenseQuery>;
export type AuthorizedQueryResult = Apollo.QueryResult<AuthorizedQuery, AuthorizedQueryVariables>;
export const GetCategoryDocument = gql`
    query getCategory($data: IdInput) {
  category(data: $data) {
    ...CategoryFragment
  }
}
    ${CategoryFragmentFragmentDoc}`;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategorySuspenseQueryHookResult = ReturnType<typeof useGetCategorySuspenseQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories {
  categories {
    ...CategoryFragment
  }
}
    ${CategoryFragmentFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation createCategory($data: CategoryParams) {
  createCategory(data: $data) {
    ...CategoryFragment
  }
}
    ${CategoryFragmentFragmentDoc}`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation updateCategory($data: UpdateCategoryParams) {
  updateCategory(data: $data) {
    ...CategoryFragment
  }
}
    ${CategoryFragmentFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation deleteCategory($data: IdInput) {
  deleteCategory(data: $data)
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const GetCustomersDocument = gql`
    query getCustomers {
  customers {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetCustomerDocument = gql`
    query getCustomer($data: IdInput) {
  customer(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation createCustomer($data: CustomerParams) {
  createCustomer(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation updateCustomer($data: UpdateCustomerParams) {
  updateCustomer(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeleteCustomerDocument = gql`
    mutation deleteCustomer($data: IdInput) {
  deleteCustomer(data: $data)
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const GetCustomerResumeDocument = gql`
    query getCustomerResume($data: IdInput) {
  customerResume(data: $data) {
    transactions {
      ...TransactionFragment
    }
    sessions {
      ...SessionFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}
${SessionFragmentFragmentDoc}`;

/**
 * __useGetCustomerResumeQuery__
 *
 * To run a query within a React component, call `useGetCustomerResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerResumeQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCustomerResumeQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>(GetCustomerResumeDocument, options);
      }
export function useGetCustomerResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>(GetCustomerResumeDocument, options);
        }
export function useGetCustomerResumeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>(GetCustomerResumeDocument, options);
        }
export type GetCustomerResumeQueryHookResult = ReturnType<typeof useGetCustomerResumeQuery>;
export type GetCustomerResumeLazyQueryHookResult = ReturnType<typeof useGetCustomerResumeLazyQuery>;
export type GetCustomerResumeSuspenseQueryHookResult = ReturnType<typeof useGetCustomerResumeSuspenseQuery>;
export type GetCustomerResumeQueryResult = Apollo.QueryResult<GetCustomerResumeQuery, GetCustomerResumeQueryVariables>;
export const GetGlobalIncomeExpenseDocument = gql`
    query getGlobalIncomeExpense {
  globalIncomesAndExpenses {
    benefit
    income
    expense
    year
    month
  }
}
    `;

/**
 * __useGetGlobalIncomeExpenseQuery__
 *
 * To run a query within a React component, call `useGetGlobalIncomeExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalIncomeExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalIncomeExpenseQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalIncomeExpenseQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>(GetGlobalIncomeExpenseDocument, options);
      }
export function useGetGlobalIncomeExpenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>(GetGlobalIncomeExpenseDocument, options);
        }
export function useGetGlobalIncomeExpenseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>(GetGlobalIncomeExpenseDocument, options);
        }
export type GetGlobalIncomeExpenseQueryHookResult = ReturnType<typeof useGetGlobalIncomeExpenseQuery>;
export type GetGlobalIncomeExpenseLazyQueryHookResult = ReturnType<typeof useGetGlobalIncomeExpenseLazyQuery>;
export type GetGlobalIncomeExpenseSuspenseQueryHookResult = ReturnType<typeof useGetGlobalIncomeExpenseSuspenseQuery>;
export type GetGlobalIncomeExpenseQueryResult = Apollo.QueryResult<GetGlobalIncomeExpenseQuery, GetGlobalIncomeExpenseQueryVariables>;
export const GetTherapistPerformanceDocument = gql`
    query getTherapistPerformance($data: DateRange!) {
  therapistPerformance(data: $data) {
    therapistName
    sessions
    totalInvoiced
    totalOhana
    totalTherapist
    therapistIrpf
    totalIrpf
    newSessions
  }
}
    `;

/**
 * __useGetTherapistPerformanceQuery__
 *
 * To run a query within a React component, call `useGetTherapistPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistPerformanceQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTherapistPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables> & ({ variables: GetTherapistPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables>(GetTherapistPerformanceDocument, options);
      }
export function useGetTherapistPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables>(GetTherapistPerformanceDocument, options);
        }
export function useGetTherapistPerformanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables>(GetTherapistPerformanceDocument, options);
        }
export type GetTherapistPerformanceQueryHookResult = ReturnType<typeof useGetTherapistPerformanceQuery>;
export type GetTherapistPerformanceLazyQueryHookResult = ReturnType<typeof useGetTherapistPerformanceLazyQuery>;
export type GetTherapistPerformanceSuspenseQueryHookResult = ReturnType<typeof useGetTherapistPerformanceSuspenseQuery>;
export type GetTherapistPerformanceQueryResult = Apollo.QueryResult<GetTherapistPerformanceQuery, GetTherapistPerformanceQueryVariables>;
export const GetOrderDocument = gql`
    query getOrder($data: IdInput) {
  order(data: $data) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export function useGetOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrdersDocument = gql`
    query getOrders {
  orders {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSuspenseQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const CreateOrderDocument = gql`
    mutation createOrder($data: OrderParams) {
  createOrder(data: $data) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation updateOrder($data: UpdateOrderParams) {
  updateOrder(data: $data) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation deleteOrder($data: IdInput) {
  deleteOrder(data: $data)
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const SearchOrdersDocument = gql`
    query searchOrders($data: OrderSearch) {
  ordersSearch(data: $data) {
    total
    orders {
      ...OrderFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useSearchOrdersQuery__
 *
 * To run a query within a React component, call `useSearchOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrdersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchOrdersQuery(baseOptions?: Apollo.QueryHookOptions<SearchOrdersQuery, SearchOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOrdersQuery, SearchOrdersQueryVariables>(SearchOrdersDocument, options);
      }
export function useSearchOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOrdersQuery, SearchOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOrdersQuery, SearchOrdersQueryVariables>(SearchOrdersDocument, options);
        }
export function useSearchOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOrdersQuery, SearchOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOrdersQuery, SearchOrdersQueryVariables>(SearchOrdersDocument, options);
        }
export type SearchOrdersQueryHookResult = ReturnType<typeof useSearchOrdersQuery>;
export type SearchOrdersLazyQueryHookResult = ReturnType<typeof useSearchOrdersLazyQuery>;
export type SearchOrdersSuspenseQueryHookResult = ReturnType<typeof useSearchOrdersSuspenseQuery>;
export type SearchOrdersQueryResult = Apollo.QueryResult<SearchOrdersQuery, SearchOrdersQueryVariables>;
export const GetOrderBySessionIdDocument = gql`
    query getOrderBySessionId($data: OrderSessionIdInput) {
  orderBySessionId(data: $data) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetOrderBySessionIdQuery__
 *
 * To run a query within a React component, call `useGetOrderBySessionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderBySessionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderBySessionIdQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOrderBySessionIdQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>(GetOrderBySessionIdDocument, options);
      }
export function useGetOrderBySessionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>(GetOrderBySessionIdDocument, options);
        }
export function useGetOrderBySessionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>(GetOrderBySessionIdDocument, options);
        }
export type GetOrderBySessionIdQueryHookResult = ReturnType<typeof useGetOrderBySessionIdQuery>;
export type GetOrderBySessionIdLazyQueryHookResult = ReturnType<typeof useGetOrderBySessionIdLazyQuery>;
export type GetOrderBySessionIdSuspenseQueryHookResult = ReturnType<typeof useGetOrderBySessionIdSuspenseQuery>;
export type GetOrderBySessionIdQueryResult = Apollo.QueryResult<GetOrderBySessionIdQuery, GetOrderBySessionIdQueryVariables>;
export const GetOrganizersDocument = gql`
    query getOrganizers {
  organizers {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetOrganizersQuery__
 *
 * To run a query within a React component, call `useGetOrganizersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizersQuery, GetOrganizersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizersQuery, GetOrganizersQueryVariables>(GetOrganizersDocument, options);
      }
export function useGetOrganizersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizersQuery, GetOrganizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizersQuery, GetOrganizersQueryVariables>(GetOrganizersDocument, options);
        }
export function useGetOrganizersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizersQuery, GetOrganizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizersQuery, GetOrganizersQueryVariables>(GetOrganizersDocument, options);
        }
export type GetOrganizersQueryHookResult = ReturnType<typeof useGetOrganizersQuery>;
export type GetOrganizersLazyQueryHookResult = ReturnType<typeof useGetOrganizersLazyQuery>;
export type GetOrganizersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizersSuspenseQuery>;
export type GetOrganizersQueryResult = Apollo.QueryResult<GetOrganizersQuery, GetOrganizersQueryVariables>;
export const GetOrganizerDocument = gql`
    query getOrganizer($data: IdInput) {
  organizer(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetOrganizerQuery__
 *
 * To run a query within a React component, call `useGetOrganizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizerQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetOrganizerQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizerQuery, GetOrganizerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizerQuery, GetOrganizerQueryVariables>(GetOrganizerDocument, options);
      }
export function useGetOrganizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizerQuery, GetOrganizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizerQuery, GetOrganizerQueryVariables>(GetOrganizerDocument, options);
        }
export function useGetOrganizerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizerQuery, GetOrganizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizerQuery, GetOrganizerQueryVariables>(GetOrganizerDocument, options);
        }
export type GetOrganizerQueryHookResult = ReturnType<typeof useGetOrganizerQuery>;
export type GetOrganizerLazyQueryHookResult = ReturnType<typeof useGetOrganizerLazyQuery>;
export type GetOrganizerSuspenseQueryHookResult = ReturnType<typeof useGetOrganizerSuspenseQuery>;
export type GetOrganizerQueryResult = Apollo.QueryResult<GetOrganizerQuery, GetOrganizerQueryVariables>;
export const CreateOrganizerDocument = gql`
    mutation createOrganizer($data: OrganizerParams) {
  createOrganizer(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type CreateOrganizerMutationFn = Apollo.MutationFunction<CreateOrganizerMutation, CreateOrganizerMutationVariables>;

/**
 * __useCreateOrganizerMutation__
 *
 * To run a mutation, you first call `useCreateOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizerMutation, { data, loading, error }] = useCreateOrganizerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizerMutation, CreateOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizerMutation, CreateOrganizerMutationVariables>(CreateOrganizerDocument, options);
      }
export type CreateOrganizerMutationHookResult = ReturnType<typeof useCreateOrganizerMutation>;
export type CreateOrganizerMutationResult = Apollo.MutationResult<CreateOrganizerMutation>;
export type CreateOrganizerMutationOptions = Apollo.BaseMutationOptions<CreateOrganizerMutation, CreateOrganizerMutationVariables>;
export const UpdateOrganizerDocument = gql`
    mutation updateOrganizer($data: UpdateOrganizerParams) {
  updateOrganizer(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type UpdateOrganizerMutationFn = Apollo.MutationFunction<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>;

/**
 * __useUpdateOrganizerMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizerMutation, { data, loading, error }] = useUpdateOrganizerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>(UpdateOrganizerDocument, options);
      }
export type UpdateOrganizerMutationHookResult = ReturnType<typeof useUpdateOrganizerMutation>;
export type UpdateOrganizerMutationResult = Apollo.MutationResult<UpdateOrganizerMutation>;
export type UpdateOrganizerMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>;
export const DeleteOrganizerDocument = gql`
    mutation deleteOrganizer($data: IdInput) {
  deleteOrganizer(data: $data)
}
    `;
export type DeleteOrganizerMutationFn = Apollo.MutationFunction<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>;

/**
 * __useDeleteOrganizerMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizerMutation, { data, loading, error }] = useDeleteOrganizerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>(DeleteOrganizerDocument, options);
      }
export type DeleteOrganizerMutationHookResult = ReturnType<typeof useDeleteOrganizerMutation>;
export type DeleteOrganizerMutationResult = Apollo.MutationResult<DeleteOrganizerMutation>;
export type DeleteOrganizerMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>;
export const GetPaymentMethodDocument = gql`
    query getPaymentMethod($data: IdInput) {
  paymentMethod(data: $data) {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;

/**
 * __useGetPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
      }
export function useGetPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
        }
export function useGetPaymentMethodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
        }
export type GetPaymentMethodQueryHookResult = ReturnType<typeof useGetPaymentMethodQuery>;
export type GetPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodLazyQuery>;
export type GetPaymentMethodSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodSuspenseQuery>;
export type GetPaymentMethodQueryResult = Apollo.QueryResult<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>;
export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods {
  paymentMethods {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsSuspenseQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const CreatePaymentMethodDocument = gql`
    mutation createPaymentMethod($data: PaymentMethodParams) {
  createPaymentMethod(data: $data) {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export type CreatePaymentMethodMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument, options);
      }
export type CreatePaymentMethodMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation updatePaymentMethod($data: UpdatePaymentMethodParams) {
  updatePaymentMethod(data: $data) {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation deletePaymentMethod($data: IdInput) {
  deletePaymentMethod(data: $data)
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const GetPeopleDocument = gql`
    query getPeople {
  people {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetPeopleQuery__
 *
 * To run a query within a React component, call `useGetPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPeopleQuery(baseOptions?: Apollo.QueryHookOptions<GetPeopleQuery, GetPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeopleQuery, GetPeopleQueryVariables>(GetPeopleDocument, options);
      }
export function useGetPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeopleQuery, GetPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeopleQuery, GetPeopleQueryVariables>(GetPeopleDocument, options);
        }
export function useGetPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPeopleQuery, GetPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPeopleQuery, GetPeopleQueryVariables>(GetPeopleDocument, options);
        }
export type GetPeopleQueryHookResult = ReturnType<typeof useGetPeopleQuery>;
export type GetPeopleLazyQueryHookResult = ReturnType<typeof useGetPeopleLazyQuery>;
export type GetPeopleSuspenseQueryHookResult = ReturnType<typeof useGetPeopleSuspenseQuery>;
export type GetPeopleQueryResult = Apollo.QueryResult<GetPeopleQuery, GetPeopleQueryVariables>;
export const GetPersonDocument = gql`
    query getPerson($data: IdInput) {
  person(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetPersonQuery__
 *
 * To run a query within a React component, call `useGetPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPersonQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
      }
export function useGetPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
        }
export function useGetPersonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
        }
export type GetPersonQueryHookResult = ReturnType<typeof useGetPersonQuery>;
export type GetPersonLazyQueryHookResult = ReturnType<typeof useGetPersonLazyQuery>;
export type GetPersonSuspenseQueryHookResult = ReturnType<typeof useGetPersonSuspenseQuery>;
export type GetPersonQueryResult = Apollo.QueryResult<GetPersonQuery, GetPersonQueryVariables>;
export const CreatePersonDocument = gql`
    mutation createPerson($data: PersonParams) {
  createPerson(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type CreatePersonMutationFn = Apollo.MutationFunction<CreatePersonMutation, CreatePersonMutationVariables>;

/**
 * __useCreatePersonMutation__
 *
 * To run a mutation, you first call `useCreatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonMutation, { data, loading, error }] = useCreatePersonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePersonMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonMutation, CreatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonMutation, CreatePersonMutationVariables>(CreatePersonDocument, options);
      }
export type CreatePersonMutationHookResult = ReturnType<typeof useCreatePersonMutation>;
export type CreatePersonMutationResult = Apollo.MutationResult<CreatePersonMutation>;
export type CreatePersonMutationOptions = Apollo.BaseMutationOptions<CreatePersonMutation, CreatePersonMutationVariables>;
export const UpdatePersonDocument = gql`
    mutation updatePerson($data: UpdatePersonParams) {
  updatePerson(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type UpdatePersonMutationFn = Apollo.MutationFunction<UpdatePersonMutation, UpdatePersonMutationVariables>;

/**
 * __useUpdatePersonMutation__
 *
 * To run a mutation, you first call `useUpdatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonMutation, { data, loading, error }] = useUpdatePersonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonMutation, UpdatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument, options);
      }
export type UpdatePersonMutationHookResult = ReturnType<typeof useUpdatePersonMutation>;
export type UpdatePersonMutationResult = Apollo.MutationResult<UpdatePersonMutation>;
export type UpdatePersonMutationOptions = Apollo.BaseMutationOptions<UpdatePersonMutation, UpdatePersonMutationVariables>;
export const DeletePersonDocument = gql`
    mutation deletePerson($data: IdInput) {
  deletePerson(data: $data)
}
    `;
export type DeletePersonMutationFn = Apollo.MutationFunction<DeletePersonMutation, DeletePersonMutationVariables>;

/**
 * __useDeletePersonMutation__
 *
 * To run a mutation, you first call `useDeletePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonMutation, { data, loading, error }] = useDeletePersonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePersonMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonMutation, DeletePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonMutation, DeletePersonMutationVariables>(DeletePersonDocument, options);
      }
export type DeletePersonMutationHookResult = ReturnType<typeof useDeletePersonMutation>;
export type DeletePersonMutationResult = Apollo.MutationResult<DeletePersonMutation>;
export type DeletePersonMutationOptions = Apollo.BaseMutationOptions<DeletePersonMutation, DeletePersonMutationVariables>;
export const GetSessionsDocument = gql`
    query getSessions {
  sessions {
    ...SessionFragment
  }
}
    ${SessionFragmentFragmentDoc}`;

/**
 * __useGetSessionsQuery__
 *
 * To run a query within a React component, call `useGetSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
      }
export function useGetSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
        }
export function useGetSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
        }
export type GetSessionsQueryHookResult = ReturnType<typeof useGetSessionsQuery>;
export type GetSessionsLazyQueryHookResult = ReturnType<typeof useGetSessionsLazyQuery>;
export type GetSessionsSuspenseQueryHookResult = ReturnType<typeof useGetSessionsSuspenseQuery>;
export type GetSessionsQueryResult = Apollo.QueryResult<GetSessionsQuery, GetSessionsQueryVariables>;
export const GetSessionDocument = gql`
    query getSession($data: IdInput) {
  session(data: $data) {
    ...SessionFragment
  }
}
    ${SessionFragmentFragmentDoc}`;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
      }
export function useGetSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
export function useGetSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionSuspenseQueryHookResult = ReturnType<typeof useGetSessionSuspenseQuery>;
export type GetSessionQueryResult = Apollo.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const CreateSessionDocument = gql`
    mutation createSession($data: SessionParams) {
  createSession(data: $data) {
    ...SessionFragment
  }
}
    ${SessionFragmentFragmentDoc}`;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const SearchSessionsDocument = gql`
    query searchSessions($data: SessionSearch) {
  searchSessions(data: $data) {
    total
    sessions {
      ...SessionFragment
    }
  }
}
    ${SessionFragmentFragmentDoc}`;

/**
 * __useSearchSessionsQuery__
 *
 * To run a query within a React component, call `useSearchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSessionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchSessionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchSessionsQuery, SearchSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSessionsQuery, SearchSessionsQueryVariables>(SearchSessionsDocument, options);
      }
export function useSearchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSessionsQuery, SearchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSessionsQuery, SearchSessionsQueryVariables>(SearchSessionsDocument, options);
        }
export function useSearchSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSessionsQuery, SearchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSessionsQuery, SearchSessionsQueryVariables>(SearchSessionsDocument, options);
        }
export type SearchSessionsQueryHookResult = ReturnType<typeof useSearchSessionsQuery>;
export type SearchSessionsLazyQueryHookResult = ReturnType<typeof useSearchSessionsLazyQuery>;
export type SearchSessionsSuspenseQueryHookResult = ReturnType<typeof useSearchSessionsSuspenseQuery>;
export type SearchSessionsQueryResult = Apollo.QueryResult<SearchSessionsQuery, SearchSessionsQueryVariables>;
export const DeleteSessionDocument = gql`
    mutation deleteSession($data: IdInput) {
  deleteSession(data: $data)
}
    `;
export type DeleteSessionMutationFn = Apollo.MutationFunction<DeleteSessionMutation, DeleteSessionMutationVariables>;

/**
 * __useDeleteSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionMutation, { data, loading, error }] = useDeleteSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionMutation, DeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionMutation, DeleteSessionMutationVariables>(DeleteSessionDocument, options);
      }
export type DeleteSessionMutationHookResult = ReturnType<typeof useDeleteSessionMutation>;
export type DeleteSessionMutationResult = Apollo.MutationResult<DeleteSessionMutation>;
export type DeleteSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSessionMutation, DeleteSessionMutationVariables>;
export const CancelSessionDocument = gql`
    mutation cancelSession($data: IdInput) {
  cancelSession(data: $data) {
    ...SessionFragment
  }
}
    ${SessionFragmentFragmentDoc}`;
export type CancelSessionMutationFn = Apollo.MutationFunction<CancelSessionMutation, CancelSessionMutationVariables>;

/**
 * __useCancelSessionMutation__
 *
 * To run a mutation, you first call `useCancelSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSessionMutation, { data, loading, error }] = useCancelSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelSessionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSessionMutation, CancelSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSessionMutation, CancelSessionMutationVariables>(CancelSessionDocument, options);
      }
export type CancelSessionMutationHookResult = ReturnType<typeof useCancelSessionMutation>;
export type CancelSessionMutationResult = Apollo.MutationResult<CancelSessionMutation>;
export type CancelSessionMutationOptions = Apollo.BaseMutationOptions<CancelSessionMutation, CancelSessionMutationVariables>;
export const EnableSessionDocument = gql`
    mutation enableSession($data: IdInput) {
  enableSession(data: $data) {
    ...SessionFragment
  }
}
    ${SessionFragmentFragmentDoc}`;
export type EnableSessionMutationFn = Apollo.MutationFunction<EnableSessionMutation, EnableSessionMutationVariables>;

/**
 * __useEnableSessionMutation__
 *
 * To run a mutation, you first call `useEnableSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSessionMutation, { data, loading, error }] = useEnableSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEnableSessionMutation(baseOptions?: Apollo.MutationHookOptions<EnableSessionMutation, EnableSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableSessionMutation, EnableSessionMutationVariables>(EnableSessionDocument, options);
      }
export type EnableSessionMutationHookResult = ReturnType<typeof useEnableSessionMutation>;
export type EnableSessionMutationResult = Apollo.MutationResult<EnableSessionMutation>;
export type EnableSessionMutationOptions = Apollo.BaseMutationOptions<EnableSessionMutation, EnableSessionMutationVariables>;
export const ExchangeSessionDocument = gql`
    mutation exchangeSession($data: IdInput) {
  exchangeSession(data: $data) {
    ...SessionFragment
  }
}
    ${SessionFragmentFragmentDoc}`;
export type ExchangeSessionMutationFn = Apollo.MutationFunction<ExchangeSessionMutation, ExchangeSessionMutationVariables>;

/**
 * __useExchangeSessionMutation__
 *
 * To run a mutation, you first call `useExchangeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeSessionMutation, { data, loading, error }] = useExchangeSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExchangeSessionMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeSessionMutation, ExchangeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeSessionMutation, ExchangeSessionMutationVariables>(ExchangeSessionDocument, options);
      }
export type ExchangeSessionMutationHookResult = ReturnType<typeof useExchangeSessionMutation>;
export type ExchangeSessionMutationResult = Apollo.MutationResult<ExchangeSessionMutation>;
export type ExchangeSessionMutationOptions = Apollo.BaseMutationOptions<ExchangeSessionMutation, ExchangeSessionMutationVariables>;
export const GetSupplierDocument = gql`
    query getSupplier($data: IdInput) {
  supplier(data: $data) {
    ...SupplierFragment
  }
}
    ${SupplierFragmentFragmentDoc}`;

/**
 * __useGetSupplierQuery__
 *
 * To run a query within a React component, call `useGetSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSupplierQuery(baseOptions?: Apollo.QueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
      }
export function useGetSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
        }
export function useGetSupplierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
        }
export type GetSupplierQueryHookResult = ReturnType<typeof useGetSupplierQuery>;
export type GetSupplierLazyQueryHookResult = ReturnType<typeof useGetSupplierLazyQuery>;
export type GetSupplierSuspenseQueryHookResult = ReturnType<typeof useGetSupplierSuspenseQuery>;
export type GetSupplierQueryResult = Apollo.QueryResult<GetSupplierQuery, GetSupplierQueryVariables>;
export const GetSuppliersDocument = gql`
    query getSuppliers {
  suppliers {
    ...SupplierFragment
  }
}
    ${SupplierFragmentFragmentDoc}`;

/**
 * __useGetSuppliersQuery__
 *
 * To run a query within a React component, call `useGetSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
      }
export function useGetSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export type GetSuppliersQueryHookResult = ReturnType<typeof useGetSuppliersQuery>;
export type GetSuppliersLazyQueryHookResult = ReturnType<typeof useGetSuppliersLazyQuery>;
export type GetSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersSuspenseQuery>;
export type GetSuppliersQueryResult = Apollo.QueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const CreateSupplierDocument = gql`
    mutation createSupplier($data: SupplierParams) {
  createSupplier(data: $data) {
    ...SupplierFragment
  }
}
    ${SupplierFragmentFragmentDoc}`;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation updateSupplier($data: UpdateSupplierParams) {
  updateSupplier(data: $data) {
    ...SupplierFragment
  }
}
    ${SupplierFragmentFragmentDoc}`;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, options);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const DeleteSupplierDocument = gql`
    mutation deleteSupplier($data: IdInput) {
  deleteSupplier(data: $data)
}
    `;
export type DeleteSupplierMutationFn = Apollo.MutationFunction<DeleteSupplierMutation, DeleteSupplierMutationVariables>;

/**
 * __useDeleteSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierMutation, { data, loading, error }] = useDeleteSupplierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupplierMutation, DeleteSupplierMutationVariables>(DeleteSupplierDocument, options);
      }
export type DeleteSupplierMutationHookResult = ReturnType<typeof useDeleteSupplierMutation>;
export type DeleteSupplierMutationResult = Apollo.MutationResult<DeleteSupplierMutation>;
export type DeleteSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>;
export const GetTherapistsDocument = gql`
    query getTherapists {
  therapists {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetTherapistsQuery__
 *
 * To run a query within a React component, call `useGetTherapistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTherapistsQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistsQuery, GetTherapistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistsQuery, GetTherapistsQueryVariables>(GetTherapistsDocument, options);
      }
export function useGetTherapistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistsQuery, GetTherapistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistsQuery, GetTherapistsQueryVariables>(GetTherapistsDocument, options);
        }
export function useGetTherapistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTherapistsQuery, GetTherapistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistsQuery, GetTherapistsQueryVariables>(GetTherapistsDocument, options);
        }
export type GetTherapistsQueryHookResult = ReturnType<typeof useGetTherapistsQuery>;
export type GetTherapistsLazyQueryHookResult = ReturnType<typeof useGetTherapistsLazyQuery>;
export type GetTherapistsSuspenseQueryHookResult = ReturnType<typeof useGetTherapistsSuspenseQuery>;
export type GetTherapistsQueryResult = Apollo.QueryResult<GetTherapistsQuery, GetTherapistsQueryVariables>;
export const GetTherapistDocument = gql`
    query getTherapist($data: IdInput) {
  therapist(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

/**
 * __useGetTherapistQuery__
 *
 * To run a query within a React component, call `useGetTherapistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTherapistQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistQuery, GetTherapistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistQuery, GetTherapistQueryVariables>(GetTherapistDocument, options);
      }
export function useGetTherapistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistQuery, GetTherapistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistQuery, GetTherapistQueryVariables>(GetTherapistDocument, options);
        }
export function useGetTherapistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTherapistQuery, GetTherapistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistQuery, GetTherapistQueryVariables>(GetTherapistDocument, options);
        }
export type GetTherapistQueryHookResult = ReturnType<typeof useGetTherapistQuery>;
export type GetTherapistLazyQueryHookResult = ReturnType<typeof useGetTherapistLazyQuery>;
export type GetTherapistSuspenseQueryHookResult = ReturnType<typeof useGetTherapistSuspenseQuery>;
export type GetTherapistQueryResult = Apollo.QueryResult<GetTherapistQuery, GetTherapistQueryVariables>;
export const CreateTherapistDocument = gql`
    mutation createTherapist($data: TherapistParams) {
  createTherapist(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type CreateTherapistMutationFn = Apollo.MutationFunction<CreateTherapistMutation, CreateTherapistMutationVariables>;

/**
 * __useCreateTherapistMutation__
 *
 * To run a mutation, you first call `useCreateTherapistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTherapistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTherapistMutation, { data, loading, error }] = useCreateTherapistMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTherapistMutation(baseOptions?: Apollo.MutationHookOptions<CreateTherapistMutation, CreateTherapistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTherapistMutation, CreateTherapistMutationVariables>(CreateTherapistDocument, options);
      }
export type CreateTherapistMutationHookResult = ReturnType<typeof useCreateTherapistMutation>;
export type CreateTherapistMutationResult = Apollo.MutationResult<CreateTherapistMutation>;
export type CreateTherapistMutationOptions = Apollo.BaseMutationOptions<CreateTherapistMutation, CreateTherapistMutationVariables>;
export const UpdateTherapistDocument = gql`
    mutation updateTherapist($data: UpdateTherapistParams) {
  updateTherapist(data: $data) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export type UpdateTherapistMutationFn = Apollo.MutationFunction<UpdateTherapistMutation, UpdateTherapistMutationVariables>;

/**
 * __useUpdateTherapistMutation__
 *
 * To run a mutation, you first call `useUpdateTherapistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTherapistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTherapistMutation, { data, loading, error }] = useUpdateTherapistMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTherapistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTherapistMutation, UpdateTherapistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTherapistMutation, UpdateTherapistMutationVariables>(UpdateTherapistDocument, options);
      }
export type UpdateTherapistMutationHookResult = ReturnType<typeof useUpdateTherapistMutation>;
export type UpdateTherapistMutationResult = Apollo.MutationResult<UpdateTherapistMutation>;
export type UpdateTherapistMutationOptions = Apollo.BaseMutationOptions<UpdateTherapistMutation, UpdateTherapistMutationVariables>;
export const DeleteTherapistDocument = gql`
    mutation deleteTherapist($data: IdInput) {
  deleteTherapist(data: $data)
}
    `;
export type DeleteTherapistMutationFn = Apollo.MutationFunction<DeleteTherapistMutation, DeleteTherapistMutationVariables>;

/**
 * __useDeleteTherapistMutation__
 *
 * To run a mutation, you first call `useDeleteTherapistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTherapistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTherapistMutation, { data, loading, error }] = useDeleteTherapistMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTherapistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTherapistMutation, DeleteTherapistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTherapistMutation, DeleteTherapistMutationVariables>(DeleteTherapistDocument, options);
      }
export type DeleteTherapistMutationHookResult = ReturnType<typeof useDeleteTherapistMutation>;
export type DeleteTherapistMutationResult = Apollo.MutationResult<DeleteTherapistMutation>;
export type DeleteTherapistMutationOptions = Apollo.BaseMutationOptions<DeleteTherapistMutation, DeleteTherapistMutationVariables>;
export const GetTherapistResumeDocument = gql`
    query getTherapistResume($data: IdInput) {
  therapistResume(data: $data) {
    year
    month
    value
    sessionPersons
    persons
    newPersons
  }
}
    `;

/**
 * __useGetTherapistResumeQuery__
 *
 * To run a query within a React component, call `useGetTherapistResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistResumeQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTherapistResumeQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>(GetTherapistResumeDocument, options);
      }
export function useGetTherapistResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>(GetTherapistResumeDocument, options);
        }
export function useGetTherapistResumeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>(GetTherapistResumeDocument, options);
        }
export type GetTherapistResumeQueryHookResult = ReturnType<typeof useGetTherapistResumeQuery>;
export type GetTherapistResumeLazyQueryHookResult = ReturnType<typeof useGetTherapistResumeLazyQuery>;
export type GetTherapistResumeSuspenseQueryHookResult = ReturnType<typeof useGetTherapistResumeSuspenseQuery>;
export type GetTherapistResumeQueryResult = Apollo.QueryResult<GetTherapistResumeQuery, GetTherapistResumeQueryVariables>;
export const GetTransactionDocument = gql`
    query getTransaction($data: IdInput) {
  transaction(data: $data) {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTransactionQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
      }
export function useGetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export function useGetTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionSuspenseQueryHookResult = ReturnType<typeof useGetTransactionSuspenseQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetTransactionsDocument = gql`
    query getTransactions {
  transactions {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = Apollo.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const SearchTransactionsDocument = gql`
    query searchTransactions($data: TransactionSearch) {
  transactionsSearch(data: $data) {
    total
    transactions {
      ...TransactionFragment
    }
    facets {
      ...TransactionFacetsFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}
${TransactionFacetsFragmentFragmentDoc}`;

/**
 * __useSearchTransactionsQuery__
 *
 * To run a query within a React component, call `useSearchTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTransactionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchTransactionsQuery, SearchTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTransactionsQuery, SearchTransactionsQueryVariables>(SearchTransactionsDocument, options);
      }
export function useSearchTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTransactionsQuery, SearchTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTransactionsQuery, SearchTransactionsQueryVariables>(SearchTransactionsDocument, options);
        }
export function useSearchTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTransactionsQuery, SearchTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTransactionsQuery, SearchTransactionsQueryVariables>(SearchTransactionsDocument, options);
        }
export type SearchTransactionsQueryHookResult = ReturnType<typeof useSearchTransactionsQuery>;
export type SearchTransactionsLazyQueryHookResult = ReturnType<typeof useSearchTransactionsLazyQuery>;
export type SearchTransactionsSuspenseQueryHookResult = ReturnType<typeof useSearchTransactionsSuspenseQuery>;
export type SearchTransactionsQueryResult = Apollo.QueryResult<SearchTransactionsQuery, SearchTransactionsQueryVariables>;
export const CreateTransactionOrderDocument = gql`
    mutation createTransactionOrder($data: TransactionParams) {
  createTransactionOrder(data: $data) {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;
export type CreateTransactionOrderMutationFn = Apollo.MutationFunction<CreateTransactionOrderMutation, CreateTransactionOrderMutationVariables>;

/**
 * __useCreateTransactionOrderMutation__
 *
 * To run a mutation, you first call `useCreateTransactionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionOrderMutation, { data, loading, error }] = useCreateTransactionOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTransactionOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionOrderMutation, CreateTransactionOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionOrderMutation, CreateTransactionOrderMutationVariables>(CreateTransactionOrderDocument, options);
      }
export type CreateTransactionOrderMutationHookResult = ReturnType<typeof useCreateTransactionOrderMutation>;
export type CreateTransactionOrderMutationResult = Apollo.MutationResult<CreateTransactionOrderMutation>;
export type CreateTransactionOrderMutationOptions = Apollo.BaseMutationOptions<CreateTransactionOrderMutation, CreateTransactionOrderMutationVariables>;
export const CreateTransactionContributionDocument = gql`
    mutation createTransactionContribution($data: ContributionParams) {
  createTransactionContribution(data: $data) {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;
export type CreateTransactionContributionMutationFn = Apollo.MutationFunction<CreateTransactionContributionMutation, CreateTransactionContributionMutationVariables>;

/**
 * __useCreateTransactionContributionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionContributionMutation, { data, loading, error }] = useCreateTransactionContributionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTransactionContributionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionContributionMutation, CreateTransactionContributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionContributionMutation, CreateTransactionContributionMutationVariables>(CreateTransactionContributionDocument, options);
      }
export type CreateTransactionContributionMutationHookResult = ReturnType<typeof useCreateTransactionContributionMutation>;
export type CreateTransactionContributionMutationResult = Apollo.MutationResult<CreateTransactionContributionMutation>;
export type CreateTransactionContributionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionContributionMutation, CreateTransactionContributionMutationVariables>;
export const CreateTransactionPaymentDocument = gql`
    mutation createTransactionPayment($data: PaymentParams) {
  createTransactionPayment(data: $data) {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;
export type CreateTransactionPaymentMutationFn = Apollo.MutationFunction<CreateTransactionPaymentMutation, CreateTransactionPaymentMutationVariables>;

/**
 * __useCreateTransactionPaymentMutation__
 *
 * To run a mutation, you first call `useCreateTransactionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionPaymentMutation, { data, loading, error }] = useCreateTransactionPaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTransactionPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionPaymentMutation, CreateTransactionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionPaymentMutation, CreateTransactionPaymentMutationVariables>(CreateTransactionPaymentDocument, options);
      }
export type CreateTransactionPaymentMutationHookResult = ReturnType<typeof useCreateTransactionPaymentMutation>;
export type CreateTransactionPaymentMutationResult = Apollo.MutationResult<CreateTransactionPaymentMutation>;
export type CreateTransactionPaymentMutationOptions = Apollo.BaseMutationOptions<CreateTransactionPaymentMutation, CreateTransactionPaymentMutationVariables>;
export const UpdateTransactionPaymentDocument = gql`
    mutation updateTransactionPayment($data: UpdatePaymentParams) {
  updateTransactionPayment(data: $data) {
    ...TransactionFragment
  }
}
    ${TransactionFragmentFragmentDoc}`;
export type UpdateTransactionPaymentMutationFn = Apollo.MutationFunction<UpdateTransactionPaymentMutation, UpdateTransactionPaymentMutationVariables>;

/**
 * __useUpdateTransactionPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionPaymentMutation, { data, loading, error }] = useUpdateTransactionPaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTransactionPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionPaymentMutation, UpdateTransactionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionPaymentMutation, UpdateTransactionPaymentMutationVariables>(UpdateTransactionPaymentDocument, options);
      }
export type UpdateTransactionPaymentMutationHookResult = ReturnType<typeof useUpdateTransactionPaymentMutation>;
export type UpdateTransactionPaymentMutationResult = Apollo.MutationResult<UpdateTransactionPaymentMutation>;
export type UpdateTransactionPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionPaymentMutation, UpdateTransactionPaymentMutationVariables>;
export const DeleteTransactionDocument = gql`
    mutation deleteTransaction($data: IdInput) {
  deleteTransaction(data: $data)
}
    `;
export type DeleteTransactionMutationFn = Apollo.MutationFunction<DeleteTransactionMutation, DeleteTransactionMutationVariables>;

/**
 * __useDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionMutation, { data, loading, error }] = useDeleteTransactionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, options);
      }
export type DeleteTransactionMutationHookResult = ReturnType<typeof useDeleteTransactionMutation>;
export type DeleteTransactionMutationResult = Apollo.MutationResult<DeleteTransactionMutation>;
export type DeleteTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>;